import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { IoMdClose } from "react-icons/io";
import services from '@api/services';

const TAEnquiry = ({ showTAForm, setShowTAForm }) => {

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    const selectedState = watch("state");

    const fetchStates = async () => {
        try {
            const res = await services.globalService.getAllState()
            if (res.status === 200) {
                setStates(res?.data?.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchStates()
    }, []);

    const fetchCities = async () => {
        try {
            const res = await services.globalService.getAllCitiesByState(selectedState)
            if (res.status === 200) {
                setCities(res?.data?.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchCities()
    }, [selectedState]);

    const onSubmit = async (data) => {
        try {
            const payload = {
                firstName: data.firstName,
                lastName: data.lastName,
                mobile: data.mobile,
                email: data.email,
                state: data.state,
                city: data.city,
                pincode: data.pincode,
                businessName: data.businessName
            }
            const res = await services.globalService.taEnqueryService(payload)
            if (res.data.status === true) {
                alert(res.data.message)
                setShowTAForm(false);
            }
        }
        catch { }
    };

    return (
        <>
            {
                showTAForm && (
                    <div className="modal-popup">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4>TA Enquiry Form</h4>
                                <span className="close" onClick={() => setShowTAForm(false)}>
                                    <IoMdClose size={22} />
                                </span>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">

                                        {/* Name */}
                                        <div className="col-md-6">
                                            <label className="label">Firstname</label>
                                            <input
                                                className="form-control"
                                                {...register("firstName", { required: "Firstname is required" })}
                                                placeholder="Enter Firstname"
                                            />
                                            {
                                                errors.firstName && (
                                                    <span className="text-danger fs-7">{errors.firstName.message}</span>
                                                )
                                            }
                                        </div>

                                        <div className="col-md-6">
                                            <label className="label">Lastname</label>
                                            <input
                                                className="form-control"
                                                {...register("lastName", { required: "Lastname is required" })}
                                                placeholder="Enter Lastname"
                                            />
                                            {
                                                errors.lastName && (
                                                    <span className="text-danger fs-7">{errors.lastName.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* Email */}
                                        <div className="col-md-6">
                                            <label className="label">Email</label>
                                            <input
                                                className="form-control"
                                                {...register("email", {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        message: "Enter a valid email address",
                                                    },
                                                })}
                                                placeholder="Enter your Email"
                                            />
                                            {
                                                errors.email && (
                                                    <span className="text-danger fs-7">{errors.email.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* Mobile */}
                                        <div className="col-md-6">
                                            <label className="label">Mobile</label>
                                            <input
                                                className="form-control"
                                                maxLength={10}
                                                {...register("mobile", {
                                                    required: "Mobile number is required",
                                                    pattern: {
                                                        value: /^[0-9]{10}$/,
                                                        message: "Enter a valid 10-digit mobile number",
                                                    },
                                                })}
                                                placeholder="Enter your Mobile"
                                            />
                                            {
                                                errors.mobile && (
                                                    <span className="text-danger fs-7">{errors.mobile.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* Pincode */}
                                        <div className="col-md-6">
                                            <label className="label">Pincode</label>
                                            <input
                                                className="form-control"
                                                maxLength={6}
                                                {...register("pincode", {
                                                    required: "Pincode is required",
                                                    pattern: {
                                                        value: /^[0-9]{6}$/,
                                                        message: "Enter a valid 6-digit pincode",
                                                    },
                                                })}
                                                placeholder="Enter your Pincode"
                                            />
                                            {
                                                errors.pincode && (
                                                    <span className="text-danger fs-7">{errors.pincode.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* State (Dynamic API) */}
                                        <div className="col-md-6">
                                            <label className="label">State</label>
                                            <select
                                                className="form-control"
                                                {...register("state", {
                                                    required: "State is required",
                                                })}
                                            >
                                                <option value="">Select State</option>
                                                {states?.map((s) => (
                                                    <option key={s.iso2} value={s.id}>
                                                        {s.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                errors.state && (
                                                    <span className="text-danger fs-7">{errors.state.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* City (Dynamic based on State) */}
                                        <div className="col-md-6">
                                            <label className="label">City</label>
                                            <select
                                                className="form-control"
                                                {...register("city", {
                                                    required: "City is required",
                                                })}
                                                disabled={!selectedState}
                                            >
                                                <option value="">Select City</option>
                                                {cities.map((c) => (
                                                    <option key={c.id} value={c.id}>
                                                        {c.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                errors.city && (
                                                    <span className="text-danger fs-7">{errors.city.message}</span>
                                                )
                                            }
                                        </div>

                                        {/* Business Name */}
                                        <div className="col-md-6">
                                            <label className="label">Business Name</label>
                                            <input
                                                className="form-control"
                                                {...register("businessName", {
                                                    required: "Business name is required",
                                                })}
                                                placeholder="Enter Business Name"
                                            />
                                            {
                                                errors.businessName && (
                                                    <span className="text-danger fs-7">{errors.businessName.message}</span>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-primary btn-block">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default TAEnquiry;
